import { SLOTS_PER_SET } from "../../shared/domain.ts";
import { slotDifficulty } from "../game/daily.ts";

/**
 * Which Slot you are on, and how hard it is meant to be.
 *
 * The Daily Set now ramps deliberately — Slot 1 comes from the top 2% of its
 * era, Slot 5 from the top 25% — and a difficulty curve the player cannot see is
 * indistinguishable from a random one. Failing the last song should read as "that
 * was the hard one", not as "this game is broken".
 *
 * Difficulty comes from `slotDifficulty` rather than a copy of the numbers, so
 * the dots cannot drift out of step with the draw.
 */
export function SlotMeter({ index, played }: { index: number; played: number }) {
  const level = slotDifficulty(index);

  return (
    <div className="slotmeter">
      <ol className="slotmeter__pips" aria-hidden="true">
        {Array.from({ length: SLOTS_PER_SET }, (_, i) => {
          const state = i < played ? "done" : i === index ? "now" : "todo";
          return <li key={i} className={`slotmeter__pip slotmeter__pip--${state}`} />;
        })}
      </ol>

      <p className="slotmeter__label">
        <span className="slotmeter__count">
          Song {index + 1} of {SLOTS_PER_SET}
        </span>
        <span className="slotmeter__sep" aria-hidden="true">
          ·
        </span>
        <span className={`slotmeter__heat slotmeter__heat--${level}`}>
          <span className="slotmeter__flames" aria-hidden="true">
            {Array.from({ length: 5 }, (_, i) => (
              <i key={i} className={i < level ? "on" : undefined} />
            ))}
          </span>
          {DIFFICULTY_WORD[level]}
        </span>
      </p>
    </div>
  );
}

const DIFFICULTY_WORD: Record<1 | 2 | 3 | 4 | 5, string> = {
  1: "warm-up",
  2: "easy",
  3: "tricky",
  4: "hard",
  5: "hardest",
};
